import React, {Component, useState, useEffect, Fragment} from "react";
import {createRoot} from 'react-dom/client';
import axios from 'axios';
import hljs from "highlight.js";
import DynamicZone from "./shared/DynamicZone";
import {STRAPI_ABOUT} from "./services/strapi";
import {getDynamicZoneQuery} from "./services/strapi";

export function AboutPage() {

    const [about, setAbout] = useState<any[]>([])

    useEffect(() => {

        let url_query = getDynamicZoneQuery(STRAPI_ABOUT)

        console.log(url_query)


        axios.get(url_query).then((d) => {
            setAbout(d['data']['data']['content']);
        });
    }, []);


    return <Fragment>
        <div className="row justify-content-center">
            <div className="col-sm-12 col-lg-10">
                <h1>About</h1>
            </div>
        </div>
            <div className="row justify-content-center">
                <div className="col-sm-12 col-lg-10">
                    <DynamicZone content={about}/>
                </div>
            </div>
    </Fragment>
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<AboutPage/>);
